// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for BucketStore, for use in the registry */ export const BucketStoreActionTypes = [
    ActionType.CreateEntityAction,
    ActionType.CreateEntityFailedAction,
    ActionType.CreateEntitySucceededAction,
    ActionType.DeleteEntityAction,
    ActionType.DeleteEntityFailedAction,
    ActionType.DeleteEntitySucceededAction,
    ActionType.DeltaSyncAction,
    ActionType.DeltaSyncSucceededAction,
    ActionType.DeltaSyncFailedAction,
    ActionType.FetchEntityAction,
    ActionType.FetchEntityFailedAction,
    ActionType.FetchEntitySucceededAction,
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.UpdateEntityAction,
    ActionType.UpdateEntityFailedAction,
    ActionType.UpdateEntitySucceededAction,
    ActionType.UnDeleteEntityAction,
    ActionType.UnDeleteEntityFailedAction,
    ActionType.UnDeleteEntitySucceededAction,
    ActionType.UndoRedoUpdateEntitySucceededAction,
    ActionType.SuspendEntityDeltaAction,
    ActionType.ResumeEntityDeltaAction,
    ActionType.DropSuspendedDeltaAction,
    ActionType.PruneBaselineChainAction
];
